import { render, staticRenderFns } from "./PaginableContentBlock.vue?vue&type=template&id=5e2eb123&"
import script from "./PaginableContentBlock.vue?vue&type=script&lang=js&"
export * from "./PaginableContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports